import Link from "next/link";
import React from "react";

const TermsPolicy = () => {
  return (
    <>
      <div className="rainbow-section-gap">
        <div className="container">
          <div className="rbt-dashboard-content">
            <div className="text-center">
              <div className="content-page pb--30">
                <h3 className="title">Terms And Condition</h3>
              </div>
            </div>
            <div className="content-page pb--50">
              <div className="chat-box-list">
                <div className="content">
                  <h4>Welcome to CyberAgric!</h4>
                  <h6> These Terms and Conditions govern your use of our website, mobile application, and services. By accessing or using CyberAgric, you agree to be bound by these Terms and Conditions and our Privacy Policy. If you do not agree with any part of these terms, please do not use our services.</h6>
                  <h4>Use of Services</h4>
                  <ol>
                    <li>
                      You must be at least 18 years old or have parental consent to use our services.
                    </li>
                    <li>
                     You agree to use CyberAgric for lawful purposes only and in compliance with all applicable laws and regulations.
                    </li>
                    <li>
                     You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                    </li>
                  </ol>

                  <h4>Intellectual Property</h4>

                  <ol>
                    <li>
                      CyberAgric and its licensors own all intellectual property rights in the website, app, and services, including but not limited to trademarks, logos, software, and content.

                    </li>
                    <li>
                      You may not modify, reproduce, distribute, or create derivative works from our content or services without our prior written consent.
                    </li>
                  </ol>

                  <h4>User Content</h4>

                  <ol>
                    <li>
                      You retain ownership of any content (e.g., images, data) you submit through our services. However, by uploading or submitting content, you grant CyberAgric a worldwide, non-exclusive, royalty-free license to use, reproduce, and display the content for the purpose of providing our services.
                    </li>
                    <li>
                      You are solely responsible for the content you submit, and you must ensure that it does not infringe on any third-party rights or violate any applicable laws.
                    </li>
                    
                  </ol>
                   <h4>Third-Party Services and Links</h4>
                  <ol>
                    <li>
                     CyberAgric may integrate or provide links to third-party services, websites, or resources. We do not endorse or assume any responsibility for the content, privacy policies, or practices of these third parties.
                    </li>
                    <li>
                      You acknowledge and agree that CyberAgric is not responsible for any damage or loss caused by your use of third-party services or resources.
                    </li>
                    
                  </ol>
                   <h4>Disclaimer of Warranties</h4>
                  <ol>
                    <li>
                      CyberAgric provides its services on an "as is" and "as available" basis without any warranties, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.

                    </li>
                    <li>
                      We do not guarantee the accuracy, completeness, or reliability of any information, recommendations, or analysis provided through our services.
                    </li>
                    
                  </ol>
                   <h4>Limitation of Liability</h4>
                  <ol>
                    <li>
                      CyberAgric shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of our services, including but not limited to damages for loss of profits, data, or business interruption.
                    </li>
                    <li>
                      Our total liability, if any, shall be limited to the amount paid by you for the services during the 6 months preceding the claim.
                    </li>
                    
                  </ol>
                   <h4>Indemnification</h4>
                  <ol>
                   
                    <li>
                      You agree to indemnify, defend, and hold harmless CyberAgric, its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including reasonable attorneys' fees) arising from your violation of these Terms and Conditions or your use of our services.
                    </li>
                    
                  </ol>
                   <h4>Termination</h4>
                  <ol>
                    <li>
                      CyberAgric reserves the right to terminate or suspend your access to our services, without prior notice or liability, for any reason, including but not limited to a breach of these Terms and Conditions.
                    </li>
                    
                  </ol>
                   <h4>Governing Law and Jurisdiction</h4>
                  <ol>
                    <li>
                      These Terms and Conditions shall be governed by and construed in accordance with the laws of the State of Wyoming.
                    </li>
                    <li>
                      Any disputes arising from or related to these Terms and Conditions shall be subject to the exclusive jurisdiction of the courts located in the State of Wyoming.
                    </li>
                    
                  </ol>
                   <h4>Changes to Terms and Conditions</h4>
                  <ol>
                    <li>
                     CyberAgric may modify or update these Terms and Conditions at any time without prior notice. Your continued use of our services after any modifications constitutes your acceptance of the updated Terms and Conditions.
                    </li>
                    
                  </ol>
                   <h4>Contact Us</h4>
                  <ol>
                    <li>
                      If you have any questions or concerns about these Terms and Conditions or our services, please contact us at: 
                      <div>
                        Address: 1309 Coffeen Ave STE 1200 Sheridan Wyoming 82801, USA
                        <br />
                        Email: info@cyberagric.com
                      </div>
                      </li>
                    
                  </ol>
                  <h6>By using CyberAgric's website, mobile application, and services, you acknowledge that you have read, understood, and agreed to be bound by these Terms and Conditions, as well as our Privacy Policy. If you do not agree with any part of these terms, please refrain from using our services.</h6>
                  <h6>This comprehensive Terms and Conditions covers the following key aspects:</h6>
                  <ol>
                    <li>
                      Use of Services: Guidelines for lawful and appropriate use, age requirements, and account responsibility.
                    </li>
                    <li>
                  Intellectual Property: Ownership of CyberAgric's intellectual property and restrictions on modification or distribution.
                    </li>
                    <li>
                      User Content: Ownership of user-submitted content and license granted to CyberAgric for providing services.
                    </li>
                    <li>
                      Third-Party Services and Links: Disclaimer of responsibility for third-party content and resources.
                    </li>
                    <li>
                      Disclaimer of Warranties: Provision of services on an "as is" and "as available" basis without warranties.
                    </li>
                    <li>
                      Limitation of Liability: Limitation of CyberAgric's liability for any damages arising from the use of services.
                    </li>
                    <li>
                      Indemnification: User's obligation to indemnify CyberAgric against claims and liabilities arising from violations.

                    </li>
                    <li>
                      Termination: CyberAgric's right to terminate or suspend access to services.
                    </li>
                    <li>
                      Governing Law and Jurisdiction: Applicable laws and jurisdiction for dispute resolution.
                    </li>
                    <li>
                      Changes to Terms and Conditions: CyberAgric's right to modify the terms and conditions without notice.
                    </li>
                    <li>
                      Contact Information: Provisions for contacting CyberAgric regarding questions or concerns.
                    </li>
                    
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPolicy;
